import { Box, Typography } from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';
import { NotificationAnnouncement } from '../../core/interfaces/notification.interface';

const AnnouncementNotificationMenuItem = ({ notification }: { notification: NotificationAnnouncement }) => (
  <Box display="flex" alignItems="center" maxWidth={250}>
    <CampaignIcon style={{ fontSize: 32, color: '#888', marginRight: 12 }} />
    <Box display="flex" flexDirection="column">
      <Typography fontSize={12} color="#888" fontWeight={500}>Nuevo comunicado</Typography>
      <Typography fontSize={15} color="#222" fontWeight={600} mt={0.5}>
        {notification?.announcement?.title || 'Nuevo comunicado'}
      </Typography>
    </Box>
  </Box>
);

export default AnnouncementNotificationMenuItem; 